<template><div><h1 id="dispositionsliste-export-fur-excel" tabindex="-1"><a class="header-anchor" href="#dispositionsliste-export-fur-excel"><span>Dispositionsliste, Export für Excel</span></a></h1>
<p>Dispositionsliste, Export für Excel — Dispositionsliste für ein Medium</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit detaillierten Informationen für die Disposition und den Einkauf von Artikeln. Es werden im Warenhandel nur Artikel mit einem bestimmten Mediumcode berücksichtigt, d.h. Artikel aus einem bestimmten Katalog. Da Wiederverkäufer nicht über den Katalog bestellen, kann für diese ein separater Zeitraum angegeben werden, aus dem die Informationen zusammengetragen werden sollen. Die Sortierung erfolgt nach Artikelnummer.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Dispositionsliste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Mediumcode:</dt>
<dd>Muss-Eingabe</dd>
<dt>WVerkauf von Datum:</dt>
<dd>gilt nur für Wiederverkauf, nur Aufträge mit Erfassungsdatum ab diesem Wert inklusive werden berücksichtigt, leer = unbegrenzt</dd>
<dt>WVerkauf bis Datum:</dt>
<dd>gilt nur für Wiederverkauf, nur Aufträge mit Erfassungsdatum bis zu diesem Wert inklusive werden berücksichtigt, leer = unbegrenzt</dd>
<dt>Ausgabe</dt>
<dd>Standard: Textdatei, Tabulator-getrennt (für Excel)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Sei</td>
<td>Seitennummer im Katalog</td>
</tr>
<tr>
<td>B.</td>
<td>Abbildungscode (z.B. Einzel-Doppelseite)</td>
</tr>
<tr>
<td>PM</td>
<td>Produkt Manager</td>
</tr>
<tr>
<td>Artikel-Bezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>Artikel-Typ</td>
<td>Artikeltyp</td>
</tr>
<tr>
<td>Artikel-Nummer</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>VKpreis</td>
<td>Verkaufspreis aktuell des Artikels (aus Artikelstamm)</td>
</tr>
<tr>
<td>MWST-Code</td>
<td>MWST-Code</td>
</tr>
<tr>
<td>Satz %</td>
<td>MWST-Satz in %</td>
</tr>
<tr>
<td>Nafra Stück</td>
<td>Anzahl Artikel, welche in den Aufträgen erfasst wurden. Retournierte Artikel werden dabei nicht gezählt, also diese verkleinern die Nachfrage nicht.</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert der Nachfrage, berechnet als einfache Muliplikation der Artikelanzahl und des Artikelpreises aus Artikelstamm. Berechnung: [Nafra Stück] * [aktueller Artikelpreis aus Artikelstamm]</td>
</tr>
<tr>
<td>Geliefert Stück</td>
<td>Anzahl &quot;geliefert&quot; des Artikels aus allen Lagerorten, Auswertung der Auftragspositionen im gewählten Medium oder Zeitraum (Wiederverkauf).</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert der &quot;gelieferten&quot; Artikel aus allen Lagerorten, Auswertung der Auftragspositionen</td>
</tr>
<tr>
<td>Retour Stück</td>
<td>Anzahl &quot;retournierte&quot; Artikel aus allen Lagerorten, Auswertung der Auftragspositionen</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert der &quot;retournierten&quot; Artikel aus allen Lagerorten, Auswertung der Auftragspositionen</td>
</tr>
<tr>
<td>Ausverk. Stück</td>
<td>Anzahl &quot;ausverkaufte&quot; Artikel aus allen Lagerorten (Artikel mit Status A, welche nicht mehr geliefert werden können)</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert der &quot;ausverkauften&quot; Artikel aus allen Lagerorten</td>
</tr>
<tr>
<td>Reserv. Stück</td>
<td>Anzahl &quot;reservierte&quot; Artikel aus allen Lagerorten, Auswertung der offenen Auftragspositionen</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert der &quot;reservierten&quot; Artikels aus allen Lagerorten</td>
</tr>
<tr>
<td>Rbr. Stück</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>HRnet Stück</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Orderb Stück</td>
<td>Anzahl &quot;bestellte&quot; Artikel für alle Lagerorte, Auswertung der offenen Bestellungen</td>
</tr>
<tr>
<td>Orderb. Wert</td>
<td>Wert der &quot;bestellten&quot; Artikel für alle Lagerorte</td>
</tr>
<tr>
<td>Lagerb. Stück</td>
<td>Gesamtbestand des Artikels in allen Lagerorten</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert des Gesamtbestandes</td>
</tr>
<tr>
<td>Engag. Stück</td>
<td>[Orderb Stück] + [Lagerb. Stück] (= offene Bestellungen und Lagerbestand)</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert [Engag. Stück]</td>
</tr>
<tr>
<td>Bedarf überl. Stück</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Bedarf unterl. Stück</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>WVerk best. Stück</td>
<td>Gesamtanzahl &quot;verkauft&quot; des Artikels, nur für Wiederverkauf, Auswertung aller Auftragspositionen</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert [Wverk best. Stück]</td>
</tr>
<tr>
<td>Gel. Stück</td>
<td>Anzahl &quot;geliefert&quot; des Artikels, nur für Wiederverkauf, Auswertung abgeschlossene Auftragspositionen</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert [Gel. Stück]</td>
</tr>
<tr>
<td>Offen Stück</td>
<td>Anzahl &quot;reservierte&quot; Artikel, nur für Wiederverkauf, Auswertung der offenen Auftragspositionen</td>
</tr>
<tr>
<td>Wert</td>
<td>Wert [Offen Stück]</td>
</tr>
<tr>
<td>EKPreis Wert</td>
<td>Einkaufspreis des Artikels aus Artikelstamm</td>
</tr>
<tr>
<td>Nafra EW</td>
<td>[Wverk best. Stück] * [EKPreis Wert] (= Nachfrage aus Wiederverkauf zu Einkaufspreisen)</td>
</tr>
<tr>
<td>Engag. EW</td>
<td>[Engag. Stück] * [EKPreis Wert] (= Einkaufspreis der am Lager vorhandenen sowie der kurzfristig verfügbaren Artikel aus Bestellungen)</td>
</tr>
</tbody>
</table>
<pre><code>    Dispoliste              Auswertung Medium 61                                                                                                            Bedarf          Bedarf          WVerk
</code></pre>
<p>Sei     B.      PM      Artikel-        Artikel-        Artikel-        VKpreis MWSt-Code       Satz    Nafra           Geliefert               Retour          Ausverk.                Reserv.         Rbr.            HRnet.          Orderb.         Lagerb.         Engag.          überl.          unterl.         Best.           Gel.            Offen           EKPreis Nafra   Engag.
Bezeichnung     Typ     Nummer                  %       Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Stück   Wert    Wert    EW      EW
0                       Poster Tinga-Tinga f. 6;5       N       PQF     30      3       7.5     2       60      2       60      0       0       0       0       0       0                                       0       0       239     7170    239     7170                                    0       0       0       0       0       0       6       12      1434
0                       TOTAL/Artikel           PQF                             2       60      2
.
0                       TOTAL/Seite                                             44      1115    44
.
TOTAL/N                                         44      1115    44      1350
.
TOTALWERT/Alles                                                 1115            1350            0               0               0                                               0               9195            9195                                            0               0               0               615     2439</p>
<p>Lesebeispiel: Vom Poster Tinga-Tinga sind 2 Stück in Aufträgen offen, an Lager liegen 239 Stück im Gesamtwert von Fr. 7'170. Es liegen keine offenen Bestellungen vor. Der Einkaufspreis beträgt 6 Fr., was 12 Fr. offenem Einkaufswert aus Aufträgen entspricht. Der Gesamtwert des Artikels am Lager beträgt zu Einkaufspreisen Fr. 1434.--.</p>
</div></template>


